<template>
    <div>
        <Clist :isFactura="true" :EmitSeccion="EmitSeccion" :regresar="false" :ShowFilas="false" :pShowBtnAdd="true" @FiltrarC="Lista" :Filtro="Filtro" :Nombre="NameList"  :isModal="EsModal" :pConfigLoad="ConfigLoad" :PNameButonNuevo="'Crear Nueva'">
            <template slot="botonextra">
                <button @click="IrACalendario" type="button" class="btn btn-01 mb-2 mr-3">Calendario</button>
                <button @click="IrAActivas" type="button" class="btn btn-01 mb-2 mr-3">Activas</button>
            </template>
			<template slot="FacturaDashboard">
				<div class="row mt-2">
					<div class="col-lg-12">
						<div class="card card-01">
							<div class="row d-flex justify-content-center">
								<div class="col-lg-1">
									<div class="card">
										<div class="card-body ml-0 mr-0 pl-0 pr-0">
											<h1 class="text-center text-info" style="font-size:48px; margin-bottom: 0.1em;">{{ Contadores.ContadorOportunidadesNuevas }}</h1>
											<h4 class="text-center" style="color:#FF831B">Nuevas</h4>
										</div>
									</div>
								</div>
								<div class="col-lg-1">
									<div class="card">
										<div class="card-body ml-0 mr-0 pl-0 pr-0">
											<h1 class="text-center text-info" style="font-size:48px; margin-bottom: 0.1em;">{{ Contadores.ContadorOportunidadesActivas }}</h1>
											<h4 class="text-center" style="color:#FF831B">Activas</h4>
										</div>
									</div>
								</div>
								<div class="col-lg-1">
									<div class="card">
										<div class="card-body ml-0 mr-0 pl-0 pr-0">
											<h1 class="text-center text-info" style="font-size:48px; margin-bottom: 0.1em;">{{ Contadores.ContadorOportunidadesEnviadas }}</h1>
											<h4 class="text-center" style="color:#FF831B">Enviadas</h4>
										</div>
									</div>
								</div>
								<div class="col-lg-1">
									<div class="card">
										<div class="card-body ml-0 mr-0 pl-0 pr-0">
											<h1 class="text-center text-info" style="font-size:48px; margin-bottom: 0.1em;">{{ Contadores.ContadorOportunidadesPerdidas }}</h1>
											<h4 class="text-center" style="color:#FF831B">Perdidas</h4>
										</div>
									</div>
								</div>
								<div class="col-lg-1">
									<div class="card">
										<div class="card-body ml-0 mr-0 pl-0 pr-0">
											<h1 class="text-center text-info" style="font-size:48px; margin-bottom: 0.1em;">{{ Contadores.ContadorOportunidadesGanadas }}</h1>
											<h4 class="text-center" style="color:#FF831B">Ganadas</h4>
										</div>
									</div>
								</div>
								<div class="col-lg-2">
									<div class="card">
										<div class="card-body">
											<h1 class="text-center text-info" style="font-size:48px; margin-bottom: 0.1em;">${{ formateoMillon(Number(Contadores.MontoOportunidadesActivas)) }}</h1>
											<h4 class="text-center" style="color:#FF831B">Monto Activas</h4>
										</div>
									</div>
								</div>
								<div class="col-lg-2">
									<div class="card">
										<div class="card-body">
											<h1 class="text-center text-danger" style="font-size:48px; margin-bottom: 0.1em;">${{ formateoMillon(Number(Contadores.MontoOportunidadesPerdidas)) }}</h1>
											<h4 class="text-center" style="color:#FF831B">Monto Perdidas</h4>
										</div>
									</div>
								</div>
								<div class="col-lg-2">
									<div class="card">
										<div class="card-body">
											<h1 class="text-center text-success" style="font-size:48px; margin-bottom: 0.1em;">${{ formateoMillon(Number(Contadores.MontoOportunidadesGanadas)) }}</h1>
											<h4 class="text-center" style="color:#FF831B">Monto Ganadas</h4>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
            <template slot="Filtros">
                <div class="form-group  mr-2">
                    <v-date-picker
                    mode='range'
                    v-model='rangeDate'>
						<template v-slot="{ inputEvents }">
  						  <input
  						    class="form-control calendar"
  						    :value="$formatRange(rangeDate)"
  						    v-on="inputEvents"
  						    readonly
  						    placeholder="Selecciona un rango de fecha para buscar"
  						  />
  						</template>
					</v-date-picker>
                </div>

                <!-- <div class="form-group  mr-2">
                    <select style="width: 150px;"  v-model="Filtro.IdTrabajador"  class="form-control">
                        <option :value="''">--Personal--</option>
                        <option v-for="(item, index) in ListaTrabajadores" :key="index" :value="item.IdTrabajador">{{item.Nombre}}</option>
                    </select>
                </div> -->

                <div class="form-group  mr-2">
                    <select style="width: 150px;"   v-model="Filtro.IdTipoServicio"  class="form-control">
                        <option :value="''" >--Tipo Servicio--</option>
                        <option v-for="(item, index) in ListaTipoServicio" :key="index" :value="item.IdTipoSer" >{{item.Concepto}}</option>
                    </select>
                </div>
				<div class="form-group mr-2">
					<select style="width: 150px;"   v-model="Filtro.Categoria"  class="form-control">
						<option :value="''" >--Categoría--</option>
						<option value="Cliente">Cliente</option>
						<option value="Prospecto">Prospecto</option>
						<option value="Suspecto">Suspecto</option>
						<option value="Inactivo">Inactivo</option>
					</select>
				</div>

                <!-- <div class="form-group  mr-2">
                    <select  v-model="Filtro.EstatusS" class="form-control">
                        <option :value="''">--Estatus --</option>
                        <option :value="'ABIERTA'">ABIERTA</option>
                        <option :value="'PENDIENTE'">PENDIENTE</option>
                        <option :value="'CERRADA'">CERRADA</option>
                        <option :value="'CANCELADA'">CANCELADA</option>
                    </select>
                </div> -->

                <div class="form-group  mr-2">
                    <button  :disabled="Disablebtn" v-b-tooltip.hover.leftbottom  @click="Lista()" title="Filtrar" type="button" class="btn btn-primary mr-1" ><i v-show="Disablebtn" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>Filtrar</button>
                </div>

            </template>


                <template slot="header">
                    <tr >
                        <th>Folio</th>
                        <th>Fecha</th>
						<th>Categoría</th>
                        <th>Cliente</th>
                        <th>Propiedad</th>
                        <th>Tipo de servicio</th>
                        <th>Observaciones</th>
                        <th>Observaciones finales</th>
                        <th>Acciones</th>
                    </tr>
                </template>
                <template slot="body">
                    <tr :class="lista.EstadoS=='CANCELADA' ? 'bg-danger' : ''" v-for="(lista,index) in ListaServicio" :key="index" >
						<td><b>{{lista.Folio }}</b></td>
                        <td> <i class="fas fa-calendar-day"></i> {{lista.FechaTrabajo}}</td>
                        <td>{{lista.Categoria}}</td>
						<td>{{lista.NomCli }}</td>
                        <td>{{lista.Sucursal }}</td>
                        <td>{{lista.Servicio }}</td>
                        <td>{{lista.Observaciones | subStr}}</td>
                        <td>{{lista.ComentarioFin | subStr}}</td>
                        <td>
                            <Cbtnaccion :pButtonEditTitle="'Crear Oportunidad'" :pDeleteShowAll="true" :pEmitSeccion="EmitSeccion" :isModal="EsModal" :Id="lista.IdServicio" :IrA="FormName" >
                                <template slot="btnaccion">

                                <button v-if="lista.EstadoS === 'CERRADA'" v-b-tooltip.hover.leftbottom  @click="Descargar(lista.IdServicio)" title="Orden de Servicio" type="button" class="btn-icon mr-2" ><i :id="'pdfOrden_' + lista.IdServicio" class="fas fa-file-pdf"></i></button>
                                <button v-if="lista.EstadoS === 'CERRADA'" v-b-tooltip.hover.leftbottom  @click="DescargarEvidencia(lista)" title="Evidencia" type="button" class="btn-icon mr-2" ><i :id="'pdfEvidencia_' + lista.IdServicio" class="fas fa-file-pdf"></i></button>
                                <!-- <button v-if="lista.EstadoS === 'CERRADA'" v-b-tooltip.hover.leftbottom  @click="OpenCorreo(lista.IdServicio)" title="Enviar Correo" type="button" class="btn-icon mr-2" data-toggle="modal" data-target="#ModalMail"  data-backdrop="static" data-keyboard="false"><i class="fas fa-envelope-open-text"></i></button> -->

                                </template>
                            </Cbtnaccion>
                        </td>
                    </tr>
					<CSinRegistros :pContIF="ListaServicio.length" :pColspan="9" ></CSinRegistros>
                </template>

        </Clist>

        <Modal :size="size" :poBtnSave="oBtnSave" :pEmitSeccion="EmitSeccion"  :Nombre="NameList" :NameModal="'oportunidadservicio'">
            <template slot="Form">
                <Form @Listar="ListaCliente" :pOrigen="'oportunidad'" :poBtnSave="oBtnSave"></Form>
            </template>
        </Modal>

        <Modal :NameModal="'ModalMail'" :size="size" :Showbutton="false"  :Nombre="'Mail'" >
            <template slot="Form">
                <Mail ></Mail>
            </template>
        </Modal>
        <Ccliente :Origen="'Oportunidad'" :TipoModal='2'></Ccliente>

</div>
</template>
<script>
import Modal from '@/components/Cmodal.vue';
import Clist from "../../../components/Clist";
import Cbtnaccion from '@/components/Cbtnaccion.vue';
import SpinnerComponent from '@/components/SpinnerComponent.vue';
import CSinRegistros from "../../../components/CSinRegistros";
import Ccliente from '@/components/Ccliente.vue';

import Form from '@/views/modulos/oportunidades/OportunidadesForm.vue'
import Mail from '@/views/modulos/servicios/Mail.vue'

export default {
    name :'listConsultasDespacho',
    components :{
        Modal,
        Clist,
        Cbtnaccion,
        Form,
        Mail,
        SpinnerComponent,
		CSinRegistros,
        Ccliente,
    },
    data() {
        return {
            EmitSeccion:"oportunidadservicio",
            Disablebtn:false,
            SpinOrden: false,
            SpinEvidencia: false,
            DisableOrden: true,
            DisableEvidencia: true,
            FormName:'objoportunidad',//Por si no es modal y queremos ir a una vista declarada en el router
            EsModal:true,//indica si es modal o no
            size :"modal-xl",
            NameList:"Nuevas Oportunidades",
            urlApi:"servicio/get",
            ListaServicio:[],
            Filtro:{
                Nombre:'',
                Placeholder:'Folio/Contrato/Cliente/Sucursal',
                TotalItem:0,
                Pagina:1,
                FechaI:'',
                FechaF:'',
                IdTrabajador:'',
                IdTipoServicio:'',
				Categoria:'',
                EstatusS:'CERRADA Y OPORTUNIDAD',
                Entrada:45,

            },
            oBtnSave:{
                isModal:true,
                EmitSeccion:'oportunidadservicio',
                nombreModal:'oportunidadservicio',
                disableBtn:false,
                toast:0,
            },
            rangeDate:{},
            ListaTrabajadores:[],
            ListaTipoServicio:[],

			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			},
			Contadores:{
				ContadorOportunidadesNuevas:0,
				ContadorOportunidadesActivas:0,
				ContadorOportunidadesEnviadas:0,
				ContadorOportunidadesPerdidas:0,
				ContadorOportunidadesGanadas:0,
				MontoOportunidadesActivas:0,
				MontoOportunidadesPerdidas:0,
				MontoOportunidadesGanadas:0
			},
			Anio:new Date().getFullYear()
        }
    },
    methods: {
        Eliminar(Id)
        {

            this.$swal({
            title: 'Esta seguro que desea eliminar este dato?',
            text: 'No se podra revertir esta acción',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No, mantener',
            showCloseButton: true,
            showLoaderOnConfirm: true
            }).then((result) => {
            if(result.value) {

                    this.$http.post(
                        'oportunidades/servicio/' + Id
                    ).then( (res) => {
                        this.$toast.success('Información eliminada');
                            this.Lista();
                    });

                }
            });
        },

       async Lista()
        {
            //this.Disablebtn = true;
			this.ConfigLoad.ShowLoader = true;
            await this.$http.get(
                this.urlApi,
                {
                    params:
                    {
                        Nombre:this.Filtro.Nombre,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina,
                        IdTipoServicio:this.Filtro.IdTipoServicio,
						Categoria:this.Filtro.Categoria,
                        RegEstatus:'A',
                        EstatusS:this.Filtro.EstatusS,
						FechaI:this.rangeDate.start,
                        FechaF:this.rangeDate.end,
                    }
                }
            ).then( (res) => {

                this.ListaServicio =res.data.data.servicio;
                this.Filtro.Entrada=res.data.data.pagination.PageSize;
                this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
                //this.Disablebtn = false;

            }).finally(()=>{
				this.ConfigLoad.ShowLoader = false;
			});

        },
		ListContadores(){
			// this.ConfigLoadContadores.ShowLoader=true;
			this.$http.get("oportunidades/contadores/get",
			{
				params:{
					Anio:this.Anio
				}
			}
			).then((res)=>{
				this.Contadores.ContadorOportunidadesNuevas=res.data.data.OportunidadesNuevas.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");;
				this.Contadores.ContadorOportunidadesActivas=res.data.data.OportunidadesActivas.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");;
				this.Contadores.ContadorOportunidadesEnviadas=res.data.data.OportunidadesEnviadas.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");;
				this.Contadores.ContadorOportunidadesGanadas=res.data.data.OportunidadesGanadas.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");;
				this.Contadores.ContadorOportunidadesPerdidas=res.data.data.OportunidadesPerdidas.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");;
				if (res.data.data.MontoOportunidadesActivas==null ? this.Contadores.MontoOportunidadesActivas=0 : this.Contadores.MontoOportunidadesActivas=res.data.data.MontoOportunidadesActivas);
				if (res.data.data.MontoOportunidadesPerdidas==null ? this.Contadores.MontoOportunidadesPerdidas=0 : this.Contadores.MontoOportunidadesPerdidas=res.data.data.MontoOportunidadesPerdidas);
				if (res.data.data.MontoOportunidadesGanadas==null ? this.Contadores.MontoOportunidadesGanadas=0 : this.Contadores.MontoOportunidadesGanadas=res.data.data.MontoOportunidadesGanadas);
				// this.ConfigLoadContadores.ShowLoader=false;
			})
		},
		formateoMillon(numero){
            let fixed = 0;
			let e=0;
			if (numero === null) {
				return null;
			} // terminate early
			if (numero === 0) {
				return "0";
			} // terminate early
			fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
			var b = numero.toPrecision(2).split("e"), // get power
				k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
				c =
					k < 1
						? numero.toFixed(0 + fixed)
						: (numero / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
				d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
				if (k==0) {
					// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
					e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}
				else{
					e = d + ["", " M", " B", " T"][k]; // append power
				}
			return e;
        },
        Descargar(IdServicio)
        {
            let ActivarSpinner = document.getElementById(`pdfOrden_${IdServicio}`);
            ActivarSpinner.setAttribute('class','fa fa-spinner fa-pulse fa-1x fa-fw');

            this.$http.get(

                'reporte/servicio',
                {
                responseType: 'blob',
                params :
                    {
                        IdServicio:IdServicio,
                    }
                }
            ).then( (response) => {

                let pdfContent = response.data;
                let file = new Blob([pdfContent], { type: 'application/pdf' });
                let fileUrl = URL.createObjectURL(file);

                window.open(fileUrl);

                ActivarSpinner.setAttribute('class','fas fa-file-pdf');

                /*
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'Servicio.pdf');
                document.body.appendChild(fileLink);
                fileLink.click();*/

            });
        },
        DescargarEvidencia(servicio)
        {
            this.$router.push({name:"mon_evidencia",params:{IdServicio:servicio.IdServicio,isMonitoreo:false,isOportunidad:true}});
        },

        get_listtrabajador(){
            this.$http.get(
            'trabajador/get',
            {
                params:{Rol:'USUARIO APP',IdPerfil:4}
            }
            ).then( (res) => {
                this.ListaTrabajadores=res.data.data.trabajador;
            });
        },

        async ListaServ()
        {
            await this.$http.get(
            'tiposervicio/get',
            {
                params:{
                    Nombre:'',
                    Entrada:50,
                    pag:0,
                    RegEstatus:'A'
                }
            }
            ).then( (res) => {
                this.ListaTipoServicio =res.data.data.tiposervicio;
            });

        },

        OpenCorreo(Id)
        {
            this.bus.$emit('MailOpen',Id);
        },
        async ListaCliente()
        {
            this.bus.$emit('ListCcliente');
        },
        IrACalendario(){
            this.$router.push({ name: "calendario" });
        },
        IrAActivas(){
            this.$router.push({ name: "activas", params: {} });
        }

    },

    filters: {
        subStr: function(string2) {
            let add = '';
            let string = (string2 == null || string2 == undefined)?'':string2;
            if(string !='')
                if(string.length>25)
                    add = '...';
            return string.substring(0,25)+add;
        }
    },
    created()
    {
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        var firstDay = new Date(y, m, 1);
        var lastDay = new Date(y, m + 1, 0);

        this.rangeDate={
            start:firstDay,
            end:lastDay
        }

		this.ListContadores();
        this.get_listtrabajador();
        this.ListaServ();

        this.bus.$off('Delete_'+this.EmitSeccion);
        this.bus.$off('List');
        this.bus.$off('Regresar');
        this.Lista();

        this.bus.$on('Delete_'+this.EmitSeccion,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List',()=>
        {
            this.Lista();
        });

        this.bus.$on('Regresar',()=>
        {
           this.$router.push({name:'despacho'});
        });
    }
}
</script>
